import { isFunction } from 'mc-ui-utils';
import React, { useEffect, useReducer, } from 'react';
import { Actions } from '../../enums/Actions';
import reducer, { AppContext, initialState } from '../../reducer';
import { hasKhazaddumBridge } from '../../utils/khazaddumbridge';
export const ProviderComponent = ({ children, }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const providerState = {
        state,
        dispatch,
    };
    useEffect(() => {
        if (hasKhazaddumBridge() &&
            isFunction(window.KhazadDumBridge.registerVolumeChangeCallback)) {
            window.onVolumeChange = (isMuted) => {
                dispatch({ type: Actions.CHANGE_AUDIO_STATUS, payload: { isMuted } });
            };
            window.KhazadDumBridge.registerVolumeChangeCallback('window.onVolumeChange');
        }
    }, []);
    return (React.createElement(AppContext.Provider, { value: providerState }, children));
};
export const connectComponent = (mapStateToProps) => (Component) => (props) => (React.createElement(AppContext.Consumer, null, ({ state }) => {
    const stateProps = isFunction(mapStateToProps)
        ? mapStateToProps(state)
        : {};
    const newProps = Object.assign({}, Object.assign({}, props), Object.assign({}, stateProps));
    return React.createElement(Component, Object.assign({}, newProps));
}));
//# sourceMappingURL=index.js.map